/* Shared confirmation. Cart mutations stay with each existing product controller. */
(() => {
  'use strict';
  if (window.ParkCartNotification) return;
  const getDialog = () => document.querySelector('[data-park-cart-notification]');
  const pendingForms = new WeakSet();
  let returnFocus = null;
  const refresh = cart => document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {
    bubbles: true, detail: {openDrawer: false, cart}
  }));
  function show(result, addedItems = []) {
    const dialog = getDialog();
    if (!dialog) return false;
    if (!dialog.open) {
      returnFocus = document.activeElement;
      dialog.showModal();
    }
    window.ParkCartNotificationFlow?.opened(result);
    return true;
  }
  async function addForm(form, submitter) {
    if (pendingForms.has(form)) return;
    pendingForms.add(form);
    const buttons = [...form.querySelectorAll('[type="submit"]')];
    const previous = buttons.map(button => button.disabled);
    const body = new FormData(form);
    if (submitter?.name && submitter.name !== 'add') body.append(submitter.name, submitter.value);
    const sectionRequest = window.ParkCartNotificationFlow?.sectionRequest();
    if (sectionRequest) { body.set('sections', sectionRequest.sections.join(',')); body.set('sections_url', sectionRequest.sections_url); }
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    buttons.forEach(button => { button.disabled = true; });
    form.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', signal: controller.signal, headers: {Accept: 'application/json'}, body
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) {
        const error = new Error(typeof result.description === 'string' ? result.description : getDialog()?.dataset.error);
        error.cartAPI = true;
        throw error;
      }
      show(result, [{id: body.get?.('id'), quantity: Number(body.get?.('quantity') || 1)}]);
      refresh(result);
      return result;
    } catch (error) {
      // An uncertain response may have changed the cart. Refresh, never retry.
      if (!error.cartAPI) refresh();
      throw error;
    } finally {
      clearTimeout(timeout);
      buttons.forEach((button, index) => { button.disabled = previous[index]; });
      form.removeAttribute('aria-busy');
      pendingForms.delete(form);
    }
  }
  window.ParkCartNotification = {show, addForm};
  document.addEventListener('click', event => {
    const cartLink = event.target.closest('#pageheader a.cart-link');
    if (!cartLink || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !getDialog()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    show();
  }, true);
  document.addEventListener('click', event => {
    const dialog = getDialog();
    if (!dialog?.open) return;
    const bounds = dialog.getBoundingClientRect();
    const outside = event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
    if (event.target.closest('[data-cart-notification-close]') || outside) dialog.close();
  });
  document.addEventListener('close', event => {
    if (!event.target.matches('[data-park-cart-notification]')) return;
    if (returnFocus?.isConnected) returnFocus.focus();
    returnFocus = null;
  }, true);
  // Legacy bundled integrations signal success through these existing events.
  document.addEventListener('theme:open-cart-drawer', () => show());
  document.addEventListener('theme:cartchanged', event => { if (event.detail?.openDrawer) show(); });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.tagName !== 'FORM' || event.defaultPrevented || !getDialog()) return;
    const action = new URL(form.action, location.origin);
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
    // Existing controllers preserve validation, selling plans and their own errors.
    if (form.matches('.product-purchase-form') || form.closest('park-pdp, [data-park-pdp], [data-lp-bundle]')) return;
    event.preventDefault();
    let status = form.querySelector('[data-park-cart-form-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.parkCartFormStatus = '';
      status.setAttribute('role', 'status');
      form.appendChild(status);
    }
    status.textContent = '';
    addForm(form, event.submitter).catch(error => {
      status.textContent = error.cartAPI ? error.message : getDialog().dataset.error;
    });
  });
})();
